import { TabPanels } from '@headlessui/react';
import PropTypes from 'prop-types';

// 'lg' exists for report tabs — panels whose whole purpose is a filterable table
// the user runs exports from. It tracks the viewport rather than a fixed box so
// a zoomed-out or tall screen gets a taller table instead of dead space, with a
// floor for short viewports (where the page scrolls instead). Tables inside it
// should size themselves the same way.
const MIN_HEIGHTS = {
  sm: 'min-h-[300px]',
  md: 'min-h-[500px]',
  lg: 'min-h-[max(640px,calc(100vh-650px))]',
};

function RcTabPanels({ children, height = 'md' }) {
  return (
    <TabPanels
      as="div"
      className={`${
        MIN_HEIGHTS[height] || MIN_HEIGHTS.sm
      } bg-white/80 p-4 shadow sm:rounded-r-lg sm:rounded-b-lg sm:px-4 sm:pb-4`}
    >
      {children}
    </TabPanels>
  );
}

RcTabPanels.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.string,
};

export default RcTabPanels;
